/* eslint-disable */
/**
 * Web Sequence Analyzer (WSA)
 * API serving data for the Web Sequence Analyzer (WSA)
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  SaveSequenceFeatureColorRequest,
  SequenceFeatureColorsResponse,
  SequenceType,
} from '../models/index';
import {
    SaveSequenceFeatureColorRequestFromJSON,
    SaveSequenceFeatureColorRequestToJSON,
    SequenceFeatureColorsResponseFromJSON,
    SequenceFeatureColorsResponseToJSON,
    SequenceTypeFromJSON,
    SequenceTypeToJSON,
} from '../models/index';

export interface ColorsRequest {
    sequenceType: SequenceType;
}

export interface SaveColorRequest {
    saveSequenceFeatureColorRequest?: SaveSequenceFeatureColorRequest;
}

/**
 * 
 */
export class ColorsApi extends runtime.BaseAPI {

    /**
     * Get current users\' colors for a given sequence type
     * Get colors
     */
    async colorsRaw(requestParameters: ColorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SequenceFeatureColorsResponse>> {
        if (requestParameters.sequenceType === null || requestParameters.sequenceType === undefined) {
            throw new runtime.RequiredError('sequenceType','Required parameter requestParameters.sequenceType was null or undefined when calling colors.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/sequenceFeatureColors/{sequenceType}`.replace(`{${"sequenceType"}}`, encodeURIComponent(String(requestParameters.sequenceType))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SequenceFeatureColorsResponseFromJSON(jsonValue));
    }

    /**
     * Get current users\' colors for a given sequence type
     * Get colors
     */
    async colors(requestParameters: ColorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SequenceFeatureColorsResponse> {
        const response = await this.colorsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create or update color from given parameter
     * Save color
     */
    async saveColorRaw(requestParameters: SaveColorRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SequenceFeatureColorsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/sequenceFeatureColors`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveSequenceFeatureColorRequestToJSON(requestParameters.saveSequenceFeatureColorRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SequenceFeatureColorsResponseFromJSON(jsonValue));
    }

    /**
     * Create or update color from given parameter
     * Save color
     */
    async saveColor(requestParameters: SaveColorRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SequenceFeatureColorsResponse> {
        const response = await this.saveColorRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
